import { Participant } from '@core/data'
import { DEFAULT_AVATAR } from './default-avatar'

export function participantAvatar(participant: Participant): string {
  return participant.large_picture_url || participant.picture_url || participant.avatar || DEFAULT_AVATAR
}
